<template>
  <div class="container">
    <div class="content">
      <div class="news">
        <div class="banner">
          <img src="@/assets/banner-news.jpg" alt="" />

          <h3>{{lang.news}}</h3>
          <div class="link">
            <label>市场公关部联系方式</label>
            <span>PRMarketing@geelyfintech.com</span>
          </div>
        </div>
      </div>

      <div class="newslist">
        <template v-for="(item, i) in list">
          <NewsItem :key="i" :row="item" />
        </template>
      </div>

      <page-footer></page-footer>
    </div>
  </div>
</template>

<script>
import NewsItem from "./newsItem";
import mapStore from "@/mixins/mapStore";
import { GetNewsList } from "@/api/api";
export default {
  components: {
    NewsItem,
  },
  mixins: [
    mapStore("", {
      getters: ["lang", "china"],
    }),
  ],
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      GetNewsList({ pageIndex: 0, pageSize: 5 }).then((res) => {
        console.log(res);
        var { code, data } = res;
        if (code === 0) {
          for (let i = 0; i < data.data.length; i++) {
            const row = data.data[i];
            if (row.imageUrl) {
                var pattern = /https:\/\/www.westmoney10.com\/api\/cos/g
                row.imageUrl = row.imageUrl.replace(pattern, process.env.VUE_APP_COS_BASE_URL)
              }
          }
          this.list = data.data || [];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 52px;
}

.banner {
  position: relative;
  img {
    display: block;
    width: 100%;
  }

  h3 {
    font-weight: 500;
    font-size: 32px;
    color: #FFFFFF;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    margin-top: -32px;
  }

  .link {
    right: 15px;
    left: 15px;
    background-color: #fff;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
    height: 110px;
    position: absolute;
    bottom: -55px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    label {
      font-size: 15px;
      color: #242a32;
      margin-bottom: 10px;
    }
    span {
      font-size: 15px;
      color: #2284f6;
    }
  }
}

.newslist {
  padding-top: 85px;
  padding: 85px 39px 0 39px;
}
</style>
